module.exports = __webpack_public_path__ + "img/coupon-icon.d29582c.png";